var React = require('react');

function Gatsby (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1250 0c-690.4 0-1250 559.6-1250 1250s559.6 1250 1250 1250 1250-559.6 1250-1250-559.6-1250-1250-1250zm-981.4 1263 968.4 968.4c-531.8-6.9-961.5-436.6-968.4-968.4zm1201.1 943.9-1176.6-1176.6c99.8-436.3 490.3-761.9 956.9-761.9 326.1 0 615.1 159.1 793.6 403.9l-135.9 119.9c-144.8-207.6-385.4-343.5-657.7-343.5-346.7 0-642 220.2-753.6 528.4l1026.5 1026.4c249.3-90.3 441-300.7 505.2-561.3h-425.4v-192.2h629c-.1 466.6-325.7 857.1-762 956.9z","fill":"#744c9e"}));
}

Gatsby.defaultProps = {"enableBackground":"new 0 0 2500 2500","viewBox":"0 0 2500 2500"};

module.exports = Gatsby;

Gatsby.default = Gatsby;
